import { render, staticRenderFns } from "./sub_behaviour_modal.vue?vue&type=template&id=b1730094&"
import script from "./sub_behaviour_modal.vue?vue&type=script&lang=js&"
export * from "./sub_behaviour_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports